export const registry = Object.create(null);
